import { Container, Stack } from '@mui/material';
import { default as Grid } from '@mui/material/Unstable_Grid2/Grid2';
import _, { get, isArray, set } from 'lodash';
import React, { FC, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useFetchAntragberechtigte } from 'src/hooks/FetchAntragsberechtigte';
import GetRecords from 'src/lib/api/GetRecords';
import { APIS } from 'src/lib/constants/apis';
import { getFieldNamefromDataPath, removeDataKeys, removeNullDeep } from 'src/utils/helper';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import MuiSnackbar from '../../../../components/ui-component/mui-snackbar/MuiSnackbar';
import NoDetailsInfo from '../../../../components/ui-component/no-details-info/NoDetailsInfo';
import { useAuthentication } from '../../../../context/AuthContext';
import FoerderProgrammContextProvider from '../../../../context/FoerderProgrammContext';
import { useFetchFoerderProgrammDetail } from '../../../../hooks/FetchFoerderProgramm';
import { useFetchOrganisationDetails } from '../../../../hooks/FetchOrganisation';
import { ANTRAGS_FORMULAREN } from '../../../../lib/constants/constant';
import { PAGES_URLS } from '../../../../lib/constants/routes';
import FoerdermittelgeberSection from './components/FoerdermittelgeberSection';
import FoerderProgrammHeroSection from './components/FoerderProgrammHeroSection';
import ProgrammBeschreibungSection from './components/ProgrammBeschreibungSection';
import ProgrammButtonsSection from './components/ProgrammButtonsSection';
import ProgrammKeywordsSection from './components/ProgrammKeywordsSection';
import ProgrammLeitung from './components/ProgrammLeitung';
import AntragMitCallsBeantragen from './content/AntragMitCallsBeantragen';
import AntragStellungGespertHinweis from './content/AntragStellungGespertHinweis';
import FreischaltungBeantragen from './content/FreischaltungBeantragen';
import SkizzeUeberspringenPopUp from './content/SkizzeUeberspringenPopUp';
import { useApplicationCreation } from './hooks/useApplicationCreation';
import { getAppData } from './utils/GetAppData';

// import schemas
import AntragSchemas from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchemas.attributes;

const FoerderProgrammDetails: FC<{}> = () => {
	const location = useLocation();
	const numericId = get(location, 'state.id');
	const { authenticatedData } = useAuthentication();

	const [showFreischaltungPopUp, setShowFreischaltunsPopUp] = useState({
		antragsFormular: '',
		foerderProgramm: -1,
	});
	const [showSkizzeUeberspringenPopUpWithDetail, setShowSkizzeUeberspringenPopUpWithDetail] = useState({});

	const [allAvailablecalls, setAllAvailablecalls] = useState<any[]>([]);
	const [showCallForProposalsPopUp, setShowCallForProposalsPopUp] = useState({
		foerderProgrammID: 0,
		foerderProgrammDetails: {},
		antragDetailsObject: {},
	});

	// Getching Data
	const { loading, data, error } = useFetchFoerderProgrammDetail(numericId);
	const { data: orgaData } = useFetchOrganisationDetails(get(authenticatedData, 'organisationId', -1));
	const { data: alleAntragberechtigte } = useFetchAntragberechtigte(orgaData);

	// Context Provider funtions
	const { wsActive, wsError, createApplication, setWsError } = useApplicationCreation();

	const handleShowFreischaltunsPopUp = (antragsFormulas: string, foerderProgramm: any) => {
		setShowFreischaltunsPopUp({ antragsFormular: antragsFormulas, foerderProgramm: foerderProgramm });
	};

	const handleShowSkizzeUeberspringenPopUp = (foerderProgramm: any) => {
		setShowSkizzeUeberspringenPopUpWithDetail(foerderProgramm);
	};

	const handleCreateApplication = async (foerderProgrammID: number, foerderProgrammDetails: any, antragDetailsObject: any) => {
		const appData = getAppData(
			foerderProgrammID,
			foerderProgrammDetails,
			get(authenticatedData, 'organisationId', -1),
			orgaData,
			antragDetailsObject,
			alleAntragberechtigte,
		);

		const callRes = await fetchCall(foerderProgrammID, antragDetailsObject);

		if (isArray(callRes) && callRes.length === 1) {
			await handleCreateApplicationWithCall(foerderProgrammID, foerderProgrammDetails, antragDetailsObject, get(callRes, '[0].id', -1));
		} else if (isArray(callRes) && callRes.length > 0) {
			// Show the pop-up to choose the call for proposals
			setAllAvailablecalls(callRes);
			setShowCallForProposalsPopUp({ foerderProgrammID, foerderProgrammDetails, antragDetailsObject });
		} else {
			// Create the application in normal way
			await createApplication(antragDetailsObject, appData);
		}
	};

	const handleCreateApplicationWithCall = async (
		foerderProgrammID: number,
		foerderProgrammDetails: any,
		antragDetailsObject: any,
		callForProposalId: number,
	) => {
		const appData = getAppData(
			foerderProgrammID,
			foerderProgrammDetails,
			get(authenticatedData, 'organisationId', -1),
			orgaData,
			antragDetailsObject,
			alleAntragberechtigte,
		);
		set(appData, getFieldNamefromDataPath(P.Call_For_Proposal.path), callForProposalId);
		await createApplication(antragDetailsObject, appData);
	};

	const fetchCall = async (foerderProgrammID: number, antragDetailsObject: any) => {
		const antragsformular = get(antragDetailsObject, 'Antragsformular', '');

		const filter = {
			Allgemein_Antragsformular: antragsformular,
			Foerderprogramm: {
				id: {
					$eq: foerderProgrammID,
				},
			},
			Allgemein_Aktiv: true,
		};
		let callRes = await GetRecords(APIS.CallForProposals, ['Foerderprogramm'], filter);

		return removeDataKeys(removeNullDeep(get(callRes, 'data', [])));
	};

	if (error) console.error(' error ', error);
	if (!numericId) {
		return <NoDetailsInfo title='Förderprogramm' goBackUrl={PAGES_URLS.FoerderProgramm} />;
	}

	return (
		<FoerderProgrammContextProvider
			foerderRichtlinieDetails={data}
			organisationDetails={orgaData}
			handleShowFreischaltungsPopUp={handleShowFreischaltunsPopUp}
			handleShowSkizzeUeberspringenPopUp={handleShowSkizzeUeberspringenPopUp}
			handleCreateApplication={handleCreateApplication}
		>
			<LoadingBackdrop open={loading || wsActive} />
			<FreischaltungBeantragen
				selectedProgrammDetails={showFreischaltungPopUp}
				show={_.values(ANTRAGS_FORMULAREN).includes(showFreischaltungPopUp.antragsFormular)}
				onClose={() =>
					setShowFreischaltunsPopUp({
						antragsFormular: '',
						foerderProgramm: -1,
					})
				}
			/>

			<SkizzeUeberspringenPopUp
				foerderProgramm={showSkizzeUeberspringenPopUpWithDetail}
				onClose={() => setShowSkizzeUeberspringenPopUpWithDetail({})}
			/>

			<AntragMitCallsBeantragen
				antragsDetails={showCallForProposalsPopUp.antragDetailsObject}
				foerderProgrammID={showCallForProposalsPopUp.foerderProgrammID}
				foerderProgrammDetails={showCallForProposalsPopUp.foerderProgrammDetails}
				handleCreateApplicationWithCall={handleCreateApplicationWithCall}
				allAvailablecalls={allAvailablecalls}
				show={_.values(ANTRAGS_FORMULAREN).includes(get(showCallForProposalsPopUp, 'antragDetailsObject.Antragsformular', ''))}
				onClose={() =>
					setShowCallForProposalsPopUp({
						foerderProgrammID: 0,
						foerderProgrammDetails: {},
						antragDetailsObject: {},
					})
				}
			/>

			<Container>
				<MuiSnackbar showSnackbar={wsError} error={wsError} closeSnackbar={() => setWsError(false)} alertMessage='Etwas is schief gelaufen' />
				<Stack spacing={3}>
					<ProgrammButtonsSection />
					<FoerderProgrammHeroSection />
					<Grid container columns={6} spacing={3}>
						<Grid xs={6} md={4} sx={{ paddingLeft: 0 }}>
							<AntragStellungGespertHinweis />
							<ProgrammBeschreibungSection />
						</Grid>
						<Grid xs={6} md={2}>
							<Stack spacing={3}>
								<ProgrammLeitung />
								<FoerdermittelgeberSection />
								<ProgrammKeywordsSection />
							</Stack>
						</Grid>
					</Grid>
				</Stack>
			</Container>
		</FoerderProgrammContextProvider>
	);
};
export default FoerderProgrammDetails;
